"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ShareDialog_1 = __importDefault(require("@cdo/apps/code-studio/components/ShareDialog"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var currentUserRedux_1 = require("@cdo/apps/templates/currentUserRedux");
var popup_window_1 = __importDefault(require("@cdo/apps/code-studio/popup-window"));
/**
 * Wrapper around ShareDialog that plumbs in the necessary props for a Lab2 project.
 */
var Lab2ShareDialog = function (_a) {
    var shareUrl = _a.shareUrl;
    var isProjectLevel = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.lab.levelProperties) === null || _a === void 0 ? void 0 : _a.isProjectLevel; }) || false;
    var appType = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.projectType; });
    var channelId = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.id; });
    var isSignedIn = (0, react_redux_1.useSelector)(function (state) { return (0, currentUserRedux_1.isSignedIn)(state.currentUser); });
    var is13Plus = (0, react_redux_1.useSelector)(function (state) { return !state.currentUser.under13; });
    // We don't currently support dance party projects in Lab2.
    var selectedSong = null;
    // TODO: support thumbnail url.
    var thumbnailUrl = null;
    // TODO: support abuse reporting.
    var exceedsAbuseThreshold = false;
    // TODO: When we support publishing, we can use this logic to determine if we can publish
    // const canPublish = isSignedIn && appType && AllPublishableProjectTypes.includes(appType);
    var canPublish = false;
    // TODO: this should come from labRedux once we support publishing.
    var isPublished = false;
    var canShareSocial = isSignedIn && is13Plus;
    if (!channelId || !appType) {
        return null;
    }
    return (react_1.default.createElement(ShareDialog_1.default, { isProjectLevel: isProjectLevel, allowSignedOutShare: appType === 'dance', shareUrl: shareUrl, selectedSong: selectedSong, thumbnailUrl: thumbnailUrl, isAbusive: exceedsAbuseThreshold, canPrint: appType === 'artist', canPublish: canPublish, isPublished: isPublished, channelId: channelId, appType: appType, onClickPopup: popup_window_1.default, canShareSocial: canShareSocial, userSharingDisabled: false }));
};
exports.default = Lab2ShareDialog;
